import { Quote } from "lucide-react";

interface FounderStoryProps {
  compact?: boolean;
}

const FounderStory = ({ compact = false }: FounderStoryProps) => {
  return (
    <div className={`${compact ? 'py-0' : 'py-20'}`}>
      <div className="max-w-4xl mx-auto">
        <div className="relative bg-card border border-border/50 rounded-2xl p-8 md:p-12 shadow-xl">
          {/* Decorative quote mark */}
          <Quote className="absolute top-6 left-6 w-12 h-12 text-primary/10" />
          
          <div className="flex flex-col md:flex-row items-start gap-8">
            {/* Photo */}
            <div className="shrink-0 mx-auto md:mx-0">
              <img
                src="/images/founder.jpg"
                alt="Roberto — Founder of QuoteSendGo"
                className="w-40 h-40 rounded-2xl object-cover border-4 border-primary/30 shadow-lg"
              />
              <div className="text-center mt-4">
                <p className="font-bold text-foreground text-lg">Roberto</p>
                <p className="text-sm text-muted-foreground">Founder, QuoteSendGo</p>
              </div>
            </div>

            {/* Story */}
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p className="text-xl font-semibold text-foreground">
                "I didn't set out to build software — I set out to solve pain points I felt and experienced in my own business every single day."
              </p>
              <p>
                My name is Roberto, and I've been running a successful construction, drywall, and painting business since 2016. As the business grew, the work got better — but the day-to-day operations got harder. Keeping up with projects, appointments, quotes, and invoices using Microsoft Excel and Google Docs became a real pain point — one I lived with personally, not one I read about in a textbook.
              </p>
              <p>
                I started searching for solutions and found platforms like Jobber. It made things look professional and my customers noticed — but at <strong className="text-foreground">$200 a month</strong>, the cost was hard to justify. And the software itself? Packed with so many bells and whistles that it was overwhelming to learn and use.
              </p>
              <p>
                So I taught myself how to code and built the tool I wished existed: something <strong className="text-foreground">simple, professional, and affordable</strong>. No bloated features. No complicated setup. Just the essentials a service business actually needs — booking, quoting, invoicing, project tracking, and getting paid.
              </p>
              <p className="text-foreground font-medium italic">
                That's how QuoteSendGo was born — built by a contractor, for contractors and service professionals everywhere.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FounderStory;
